import { Button, styled, Popover } from '@moleculeone/ui';
import { useState } from 'react';
import { ISynthesis } from '@moleculeone/tree';

import { saveAsJson } from '@f/utils/export';

function buildReactatorFormat(synthesis: ISynthesis) {
  const { compounds, reactions } = synthesis;

  const target = compounds[0].smiles;

  const transformedReactions = Object.values(reactions).flatMap(reaction => {
    const { smiles } = reaction;
    const parsedSmiles = smiles.split('>>', 2);
    return {
      product: parsedSmiles[1],
      substrate: parsedSmiles[0],
    };
  });

  return [
    {
      target,
      best_path_smiles: transformedReactions,
    },
  ];
}

const StyledButton = styled(Button, {
  fontFamily: '$mono',
});

interface DownloadSynthesisPopoverProps {
  synthesis: ISynthesis;
}

export function DownloadSynthesisPopover(props: DownloadSynthesisPopoverProps) {
  const { synthesis } = props;
  const [isOpen, setIsOpen] = useState(false);

  function exportPathwayFormat() {
    saveAsJson(synthesis, 'synthesis_pathway_format.json');
  }

  function exportReactatorFormat() {
    const res = buildReactatorFormat(synthesis);
    saveAsJson(res, 'synthesis_reactator_format.json');
  }

  const handleExport = (format: string) => {
    switch (format) {
      case 'pathway':
        exportPathwayFormat();
        break;
      case 'reactator':
        exportReactatorFormat();
        break;
      default:
        break;
    }
    setIsOpen(false);
  };

  return (
    <Popover
      hasArrow
      hasClose={false}
      trigger={
        <StyledButton text="Export synthesis" size="small" weight="minimal" theme="purple" />
      }
      open={isOpen}
      onOpenChange={(isOpen: boolean) => {
        setIsOpen(isOpen);
      }}
      contentProps={{
        css: {
          display: 'flex',
          gap: '$3',
        },
      }}
    >
      <StyledButton
        weight="outlined"
        size="small"
        text="pathway format"
        onClick={() => handleExport('pathway')}
      />
      <StyledButton
        weight="outlined"
        size="small"
        text="reactator format"
        onClick={() => handleExport('reactator')}
      />
    </Popover>
  );
}
